import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import swal from "@sweetalert/with-react";
import { Link } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import ResponseLoader from "../../Forms/ShortCutComponents/ResponseLoader";
import { baseurl } from "../../../baseurl";
import { checkPermission } from "../../../Helper";
import { craveImg } from "./helpers";
import "./craveLoyalty.css";

const token = localStorage.getItem("token");

const toDateInput = (d) => (d ? moment(d).format("YYYY-MM-DD") : "");

export default function AddCravePromotion(props) {
  const state = props.location?.state || {};
  const editPromo = state.updateCheck === 2 ? state.promo : null;
  const isEdit = !!editPromo;

  const [brandSlug] = useState(state.brandSlug || "");
  const [loadingResponse, setLoadingResponse] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [form, setForm] = useState({
    title: editPromo?.title || "",
    body: editPromo?.body || "",
    badge: editPromo?.badge || "",
    bonusPoints: editPromo?.bonus_points ? Number(editPromo.bonus_points) : "",
    validFrom: toDateInput(editPromo?.valid_from),
    validTill: toDateInput(editPromo?.valid_till),
    sortOrder: editPromo?.sort_order ?? 0,
    imageUrl: editPromo?.image_url || "",
    isActive:
      editPromo?.is_active === undefined
        ? true
        : editPromo.is_active === 1 || editPromo.is_active === true,
  });

  useEffect(() => {
    asyncRollCheck(0); 
    if (isEdit && editPromo?.id) getPromo(editPromo.id);
  
  }, []);

  const asyncRollCheck = async (value) => {
    let hasPermission = await checkPermission("/inCirclePromotionsOverview", value);
    return hasPermission ? true : false;
  };

  const getPromo = (id) => {
    axios
      .get(`${baseurl}/loyalty/promotions/${id}`, {
        headers: { authorization: token },
      })
      .then((res) => {
        const d = res.data?.data;
        if (!d) return;
        setForm({
          title: d.title || "",
          body: d.body || "",
          badge: d.badge || "",
          bonusPoints: d.bonus_points ? Number(d.bonus_points) : "",
          validFrom: toDateInput(d.valid_from),
          validTill: toDateInput(d.valid_till),
          sortOrder: d.sort_order ?? 0,
          imageUrl: d.image_url || "",
          isActive: d.is_active === 1 || d.is_active === true,
        });
      })
      .catch((err) => console.log(err));
  };

  const set = (name, value) => setForm((p) => ({ ...p, [name]: value }));

  const onPickImage = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = ""; 
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) {
      swal({ title: "Too large", text: "Max image size is 10 MB", icon: "warning" });
      return;
    }
    setUploading(true);
    try {
      const dataUrl = await new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.onload = () => resolve(fr.result);
        fr.onerror = reject;
        fr.readAsDataURL(file);
      });
      const res = await axios.post(
        `${baseurl}/loyalty/upload`,
        { filename: file.name, data: dataUrl },
        { headers: { authorization: token } }
      );
      setUploading(false);
      if (res.data?.code === "200" && res.data.url) {
        set("imageUrl", res.data.url);
      } else {
        swal({
          title: "Upload failed",
          text: res.data?.message || "Could not upload image",
          icon: "error",
        });
      }
    } catch (err) {
      console.log(err);
      setUploading(false);
      swal({
        title: "Upload failed",
        text: err.response?.data?.message || "Could not upload image",
        icon: "error",
      });
    }
  };

  const validate = () => {
    if (!brandSlug) return "Brand is missing";
    if (!form.title.trim()) return "Title is required";
    if (form.validFrom && form.validTill && form.validFrom > form.validTill)
      return "“Valid from” must be before “Valid till”";
    return null;
  };

  const payload = () => ({
    brandSlug,
    title: form.title.trim(),
    body: form.body || undefined,
    badge: form.badge || undefined,
    bonusPoints: form.bonusPoints === "" ? undefined : Number(form.bonusPoints),
    validFrom: form.validFrom || null,
    validTill: form.validTill || null,
    sortOrder: Number(form.sortOrder) || 0,
    imageUrl: form.imageUrl || "",
  });

  const isOk = (res) => res?.data?.code === "200";

  const onSave = async () => {
    if (await asyncRollCheck(isEdit ? 2 : 1)) return; 
    const err = validate();
    if (err) {
      swal({ title: "Required", text: err, icon: "warning" });
      return;
    }
    setLoadingResponse(true);
    try {
      let res;
      if (isEdit) {
        res = await axios.put(
          `${baseurl}/loyalty/promotions/${editPromo.id}`,
          { ...payload(), isActive: form.isActive },
          { headers: { authorization: token } }
        );
      } else {
        res = await axios.post(`${baseurl}/loyalty/promotions`, payload(), {
          headers: { authorization: token },
        });
      }
      setLoadingResponse(false);
      if (isOk(res)) {
        await Swal.fire(
          "Saved!",
          isEdit ? "Promotion updated." : "Promotion created.",
          "success"
        );
        props.history.push("/inCirclePromotionsOverview");
      } else {
        swal({
          title: "Failed!",
          text: res.data?.message || "Could not save promotion",
          icon: "error",
        });
      }
    } catch (e) {
      console.log(e);
      setLoadingResponse(false);
      swal({
        title: "Failed!",
        text: e.response?.data?.message || "Could not save promotion",
        icon: "error",
      });
    }
  };

  const fmt = (d) => (d ? moment(d).format("DD MMM YYYY") : "—");

  return (
    <div className="crave-wrap">
      {loadingResponse && <ResponseLoader />}

      <div className="crave-hero">
        <div className="crave-hero-row">
          <div>
            <div className="crave-hero-eyebrow">
              inCircle Loyalty{brandSlug ? ` · ${brandSlug}` : ""}
            </div>
            <h1>{isEdit ? "Edit Promotion" : "New Promotion"}</h1>
            <p>
              A marketing banner for the app’s Special Offers slider. Set a
              validity window so it shows and hides automatically.
            </p>
          </div>
          <div className="crave-hero-actions">
            <Link
              to="/inCirclePromotionsOverview"
              className="crave-btn crave-btn-light"
            >
              <i className="fa fa-arrow-left" aria-hidden="true"></i>
              Back
            </Link>
          </div>
        </div>
      </div>

      <div className="crave-formgrid" style={{ marginTop: 20 }}>
        <div className="crave-panel">
          <h2>Promotion details</h2>
          <div className="sub">
            Fields marked <span className="req">*</span> are required.
          </div>

          <div className="crave-field">
            <label>
              Title <span className="req">*</span>
            </label>
            <input
              className="crave-input"
              type="text"
              value={form.title}
              onChange={(e) => set("title", e.target.value)}
              placeholder="e.g. Weekend Brunch Special"
            />
          </div>

          <div className="crave-field">
            <label>Body</label>
            <textarea
              className="crave-input"
              value={form.body}
              onChange={(e) => set("body", e.target.value)}
              placeholder="Short description shown under the title…"
            />
          </div>

          <div className="crave-two">
            <div className="crave-field">
              <label>Badge</label>
              <input
                className="crave-input"
                type="text"
                value={form.badge}
                onChange={(e) => set("badge", e.target.value)}
                placeholder="e.g. WEEKEND"
              />
            </div>
            <div className="crave-field">
              <label>Bonus points multiplier</label>
              <input
                className="crave-input"
                type="number"
                min="0"
                step="0.5"
                value={form.bonusPoints}
                onChange={(e) => set("bonusPoints", e.target.value)}
                onWheel={(e) => e.target.blur()}
                placeholder="e.g. 2"
              />
            </div>
          </div>

          <div className="crave-section-label">Schedule</div>
          <div className="crave-two">
            <div className="crave-field">
              <label>Valid from</label>
              <input
                className="crave-input"
                type="date"
                value={form.validFrom}
                onChange={(e) => set("validFrom", e.target.value)}
              />
            </div>
            <div className="crave-field">
              <label>Valid till</label>
              <input
                className="crave-input"
                type="date"
                value={form.validTill}
                onChange={(e) => set("validTill", e.target.value)}
              />
            </div>
          </div>

          <div className="crave-section-label">Display</div>
          <div className="crave-field">
            <label>Banner image</label>
            <div className="crave-upload">
              <label className="crave-btn crave-btn-ghost crave-btn-sm crave-upload-btn">
                <i className={`fa fa-${uploading ? "spinner fa-spin" : "upload"}`} />
                {uploading ? "Uploading…" : "Upload image"}
                <input
                  type="file"
                  accept="image/png,image/jpeg,image/webp,image/gif"
                  onChange={onPickImage}
                  disabled={uploading}
                  style={{ display: "none" }}
                />
              </label>
              {form.imageUrl ? (
                <button
                  type="button"
                  className="crave-btn crave-btn-danger crave-btn-sm"
                  onClick={() => set("imageUrl", "")}
                >
                  <i className="fa fa-times" />
                  Remove
                </button>
              ) : null}
            </div>
            <input
              className="crave-input"
              type="text"
              value={form.imageUrl}
              onChange={(e) => set("imageUrl", e.target.value)}
              placeholder="…or paste an image URL"
              style={{ marginTop: 10 }}
            />
            <div className="hint">
              JPG, PNG, WEBP or GIF · max 10 MB · recommended ~16:9 banner.
            </div>
          </div>
          <div className="crave-two">
            <div className="crave-field">
              <label>Sort order</label>
              <input
                className="crave-input"
                type="number"
                value={form.sortOrder}
                onChange={(e) => set("sortOrder", e.target.value)}
                onWheel={(e) => e.target.blur()}
                placeholder="0"
              />
              <div className="hint">Lower shows first in the slider.</div>
            </div>
            {isEdit && (
              <div className="crave-field">
                <label>Status</label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    paddingTop: 8,
                  }}
                >
                  <input
                    id="promo-active"
                    type="checkbox"
                    checked={form.isActive}
                    onChange={(e) => set("isActive", e.target.checked)}
                  />
                  <label
                    htmlFor="promo-active"
                    style={{ margin: 0, fontWeight: 500 }}
                  >
                    {form.isActive ? "Live on the slider" : "Hidden"}
                  </label>
                </div>
              </div>
            )}
          </div>

          <div className="crave-formfooter">
            <Link
              to="/inCirclePromotionsOverview"
              className="crave-btn crave-btn-ghost"
            >
              Cancel
            </Link>
            <button className="crave-btn crave-btn-success" onClick={onSave}>
              <i className="fa fa-check" />
              {isEdit ? "Update Promotion" : "Create Promotion"}
            </button>
          </div>
        </div>

        <div className="crave-preview">
          <div className="crave-pv-banner">
            {form.imageUrl ? (
              <img
                src={craveImg(form.imageUrl)}
                alt={form.title}
                onError={(e) => (e.target.style.display = "none")}
              />
            ) : (
              <i className="fa fa-image" />
            )}
            {form.badge && <span className="crave-promo-tag">{form.badge}</span>}
          </div>
          <div className="crave-preview-body">
            <div
              className="crave-promo-title"
              style={{ fontSize: "1.05rem", marginBottom: 6 }}
            >
              {form.title || "Untitled promotion"}
            </div>
            {form.body && (
              <div className="crave-promo-text" style={{ marginBottom: 10 }}>
                {form.body}
              </div>
            )}
            <div className="crave-promo-meta">
              <span className="crave-meta-chip">
                <i className="fa fa-calendar" />
                {fmt(form.validFrom)} – {fmt(form.validTill)}
              </span>
              {Number(form.bonusPoints) > 0 && (
                <span className="crave-meta-chip bonus">
                  <i className="fa fa-bolt" />
                  {Number(form.bonusPoints)}× points
                </span>
              )}
            </div>
            <div className="crave-preview-note">
              <i className="fa fa-info-circle" style={{ marginTop: 2 }} />
              The app shows this only while active and within the validity
              window — no app changes needed.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
